import { render } from "./VulInfoTab.vue?vue&type=template&id=390bea82"
import script from "./VulInfoTab.vue?vue&type=script&lang=js"
export * from "./VulInfoTab.vue?vue&type=script&lang=js"

import "./VulInfoTab.vue?vue&type=style&index=0&id=390bea82&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__